import React, { useEffect } from "react";
import PropTypes, { func } from "prop-types";
import { connect } from "react-redux";
import * as style from "./styles.module.scss";
import { isMobile } from "../../helpers";
import { mapToMainBranch } from "../../helpers/nearestBranch";
import { latestJobsRequestData } from "../../redux/actions";

const setMarker = (map, position) => {
  return new window.google.maps.Marker({
    position,
    map,
    icon: {
      url: "https://maps.google.com/mapfiles/kml/paddle/blu-blank.png",
    },
    id: 0,
  });
};

const initMap = (branch) => {
  const mapCenter = new window.google.maps.LatLng(branch.lat, branch.long);

  const mapOptions = {
    zoom: 17,
    center: mapCenter,
    mapTypeControl: false,
    fullscreenControl: false,
  };

  const map = new window.google.maps.Map(
    document.getElementById("map_canvas"),
    mapOptions
  );

  setMarker(map, mapCenter);
};

const loadMapsScripts = (currentBranch) => {
  const s = document.createElement("script");
  s.type = "text/javascript";
  s.src = `//maps.googleapis.com/maps/api/js?key=AIzaSyDG-GFLE-1iLlaPpX0jUNirqQ_FWItqDVw&libraries=geometry,places`;
  const x = document.getElementsByTagName("script")[0];
  x.parentNode.insertBefore(s, x);
  // Below is important.
  // We cannot access google.maps until it's finished loading
  s.addEventListener("load", (e) => {
    initMap(currentBranch);
  });
};

const BranchDetails = ({ responsibleTeam, branches, rtw = false }) => {
  const currentBranch = branches.filter(
    (branch) => branch.code === mapToMainBranch(responsibleTeam)
  )[0];

  if (currentBranch) {
    const branchPage =
      currentBranch.name &&
      currentBranch.name.replace(/'/g, "").replace(/ /g, "-").toLowerCase();

    useEffect(() => {
      if (window.google && window.google.maps) {
        initMap(currentBranch);
      } else {
        loadMapsScripts(currentBranch);
      }
    }, []);

    const openingHoursHTML = {
      __html: currentBranch.openingHours,
    };

    return rtw ? (
      <div id="branchDetails">
        <div className={"mt-2"}>
          <div
            className={style.branchDetails__content}
            style={{ height: "auto" }}
          >
            <a
              className={`btn btn-outline-info font-weight-bold text-dark ${style.branchDetails__info_button_bottom_mobile}`}
              href={`https://www.hrgo.co.uk/branches/${branchPage}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              Go to branch page
            </a>
            <div className={style.branchDetails__map} id="map_canvas" />
            <div
              className={"ml-md-1"}
              style={{
                minWidth: `calc(max(${
                  currentBranch.address
                    ? currentBranch.address.length * 0.18
                    : 0
                }em, 260px))`,
              }}
            >
              <div className={"font-weight-bold"}>{currentBranch.name}</div>
              <div
                className={`mb-1 ${style.branchDetails__info_address}`}
                style={{
                  width: `${
                    currentBranch.address
                      ? currentBranch.address.length * 0.18
                      : 0
                  }em`,
                }}
              >
                {currentBranch.address}
              </div>
              <a
                className={`btn btn-outline-info font-weight-bold text-dark mb-2 ${style.branchDetails__info_button}`}
                href={
                  (isMobile
                    ? "https://www.google.com/maps?saddr=My+Location&daddr="
                    : "https://www.google.com/maps?daddr=") +
                  currentBranch.address
                }
                target="_blank"
                rel="noopener noreferrer"
              >
                Get directions
              </a>
              <div className={"mb-2"}>
                <div
                  className={"font-weight-bold"}
                  style={{ marginBottom: "8px" }}
                >
                  Opening Hours
                </div>
                <div
                  dangerouslySetInnerHTML={openingHoursHTML}
                  className={style.branchDetails__info_opening}
                />
              </div>
              <div className={"mb-2"}>
                <div
                  className={"font-weight-bold"}
                  style={{ marginBottom: "8px" }}
                >
                  Contact
                </div>
                <div>
                  <a
                    className={style.branchDetails__info_contact_link}
                    href={`tel:${currentBranch.telephone}`}
                  >
                    {currentBranch.telephone}
                  </a>
                </div>
              </div>
              <a
                className={`btn btn-outline-info font-weight-bold text-dark d-none d-md-inline-block mt-1`}
                href={`https://www.hrgo.co.uk/branches/${branchPage}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                Go to branch page
              </a>
            </div>
          </div>
          <p
            style={{
              textAlign: "left",
              maxWidth: "784px",
              margin: "0 auto",
              marginTop: "50px",
            }}
          >
            For support with your account, please contact our Customer Success
            team, Monday - Friday between 9am - 5pm
            <br /> on{" "}
            <a href="tel:01233515169" style={{ textDecoration: "underline" }}>
              01233 515169
            </a>{" "}
            or via email at{" "}
            <a
              href="mailto:customer.success@hrgo.co.uk"
              style={{ textDecoration: "underline" }}
            >
              customer.success@hrgo.co.uk
            </a>
          </p>
        </div>
      </div>
    ) : (
      <div className={"container"} id="branchDetails">
        <div className={"mt-2"}>
          <h3 className={style.branchDetails__title}>Your local branch</h3>
          <div className={`shadow rounded ${style.branchDetails__content}`}>
            <a
              className={`btn btn-outline-info font-weight-bold text-dark ${style.branchDetails__info_button_bottom_mobile}`}
              href={`https://www.hrgo.co.uk/branches/${branchPage}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              Go to branch page
            </a>
            <div className={style.branchDetails__map} id="map_canvas" />
            <div
              className={style.branchDetails__info}
              style={{
                minWidth: `calc(max(${
                  currentBranch.address
                    ? currentBranch.address.length * 0.2678
                    : 0
                }em, 360px))`,
              }}
            >
              <div className={style.branchDetails__info_name}>
                {currentBranch.name}
              </div>
              <div
                className={style.branchDetails__info_address}
                style={{
                  width: `${
                    currentBranch.address
                      ? currentBranch.address.length * 0.2678
                      : 0
                  }em`,
                }}
              >
                {currentBranch.address}
              </div>
              <a
                className={`btn btn-outline-info font-weight-bold text-dark ${style.branchDetails__info_button}`}
                href={
                  (isMobile
                    ? "https://www.google.com/maps?saddr=My+Location&daddr="
                    : "https://www.google.com/maps?daddr=") +
                  currentBranch.address
                }
                target="_blank"
                rel="noopener noreferrer"
              >
                Get directions
              </a>
              <div>
                <div className={style.branchDetails__info_opening_title}>
                  Opening Hours
                </div>
                <div
                  dangerouslySetInnerHTML={openingHoursHTML}
                  className={style.branchDetails__info_opening}
                />
              </div>
              <div>
                <div className={style.branchDetails__info_contact}>Contact</div>
                <div>
                  <a
                    className={style.branchDetails__info_contact_link}
                    href={`tel:${currentBranch.telephone}`}
                  >
                    {currentBranch.telephone}
                  </a>
                </div>
              </div>
              <a
                className={`btn btn-outline-info font-weight-bold text-dark ${style.branchDetails__info_button_bottom}`}
                href={`https://www.hrgo.co.uk/branches/${branchPage}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                Go to branch page
              </a>
            </div>
          </div>
          <p
            style={{
              textAlign: "center",
              maxWidth: "784px",
              margin: "0 auto",
              marginTop: "50px",
              paddingBottom: "50px",
            }}
          >
            For support with your account, please contact our Customer Success
            team, Monday - Friday between 9am - 5pm
            <br /> on 01233 515169 or via email at{" "}
            <a href="mailto:customer.success@hrgo.co.uk">
              customer.success@hrgo.co.uk
            </a>
          </p>
        </div>
      </div>
    );
  }

  return null;
};

BranchDetails.propTypes = {
  responsibleTeam: PropTypes.string,
  branches: PropTypes.arrayOf(
    PropTypes.shape({
      code: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      lat: PropTypes.number.isRequired,
      long: PropTypes.number.isRequired,
      address: PropTypes.string,
      openingHours: PropTypes.string,
      telephone: PropTypes.string,
    })
  ).isRequired,
  requestJobsData: func,
};

const mapStateToProps = ({
  core: {
    app: { responsibleTeam },
    umbracoContent: { branches },
  },
}) => ({
  responsibleTeam,
  branches,
});

const mapDispatchToProps = {
  requestJobsData: latestJobsRequestData,
};

const withRedux = connect(mapStateToProps, mapDispatchToProps);

export default withRedux(BranchDetails);
